import PropTypes from 'prop-types';
import styled from 'styled-components';

export const StyledList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > li {
    flex-basis: ${props => props.theme.itemWidth + '%'};
    min-height: ${props =>
      props.theme.itemHeight >= 1 && props.theme.itemHeight + 'vh'};
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  &.case-study-list {
    max-width: 1920px;
    margin: 0 auto;
    li {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        max-width: 720px;
      }
    }
    > li:nth-child(odd) .cardDetails {
      align-self: flex-start;
      transform-origin: bottom left;
      text-align: left;
      > .container {
        align-items: flex-start;
      }
    }
    > li:nth-child(even) .cardDetails {
      align-self: flex-end;
      transform-origin: bottom right;
      text-align: right;
      > .container {
        align-items: flex-end;
      }
    }
    @media (min-width: 1920px) {
      li {
        margin: 2.4rem 0;
      }
    }
  }
`;

StyledList.propTypes = {
  className: PropTypes.oneOf(['case-study-list', null]),
  theme: PropTypes.shape({
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number,
  }),
};
StyledList.defaultProps = {
  theme: {
    itemWidth: 33,
    itemHeight: 0,
  },
};
